import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { PWA_TAB_PERMISSIONS } from '@/auth/permissions';
import { useSession } from '@/auth/SessionContext';

type Props = {
  children: ReactNode;
  path: string;
};

export function RequirePwaPermission({ children, path }: Props) {
  const { jwt, can, permissionsLoaded } = useSession();
  const perm = PWA_TAB_PERMISSIONS[path];
  if (!jwt) return <Navigate to="/login" replace />;
  /** Tras pull-to-refresh, `/me` aún no llegó: no mandar a inicio por permisos vacíos. */
  if (perm && !permissionsLoaded) return children;
  if (perm && !can(perm)) return <Navigate to="/" replace />;
  return children;
}
